import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import style from "./burger-menu-small-item.css";

function BurgerMenuSmallItem({ renderText, renderChevron, href, onClickEvent }) {
    return (
        <li>
            <div className={style.smallMenuItem}>
                <a href={href} onClick={onClickEvent}>
                    <div className={style.smallMenuItemContent}>
                        <p>{renderText}</p>
                        {renderChevron && (
                            <div className={style.menuItemChevron}>
                                <SVGIcon name="chevron" />
                            </div>
                        )}
                    </div>
                </a>
            </div>
        </li>
    );
}

export default BurgerMenuSmallItem;

BurgerMenuSmallItem.propTypes = {
    renderText: PropTypes.string.isRequired,
    renderChevron: PropTypes.bool,
    href: PropTypes.string,
    onClickEvent: PropTypes.func,
};

BurgerMenuSmallItem.defaultProps = {
    renderText: "",
    renderChevron: false,
    href: null,
};
